export default {
  install: (app) => {
    const $router = app.config.globalProperties.$router
    const $store = app.config.globalProperties.$store

    let pendingRoute = null

    $router.beforeEach((to, from) => {
      const isSamePage = from.name === to.name && JSON.stringify(from.params) === JSON.stringify(to.params)
      const routesToLoginPage = to.name === 'login'

      if (isSamePage || routesToLoginPage) {
        return true
      }

      if ($store.state.unsavedChanges.unsavedChanges.length) {
        pendingRoute = to

        $store.commit('unsavedChanges/SET_SHOW_OVERLAY', true)

        return false
      }
    })

    app.config.globalProperties.$unsavedGuard = {
      continueNavigation () {
        if (pendingRoute) {
          const route = pendingRoute

          pendingRoute = null
          $router.push(route)
        }
      },
      cancelNavigation () {
        pendingRoute = null
      },
    }
  },
}
